import { useEffect } from 'react';
import { useLocationParams } from 'hooks';

/** Mirrors the "search by creative name" chip filter to the URL. */
export const useCreativeNameFilterUrlSync = (filterByName: string[]) => {
  const { setFilterCreativesByName } = useLocationParams();

  useEffect(() => {
    setFilterCreativesByName(filterByName ?? []);
  }, [filterByName, setFilterCreativesByName]);
};
